// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:42:48

export default {
  "id": "hexon-rush",
  "slug": "hexon-rush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/12a38c7bb33a453eacc5c5cd5502c8f1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/12a38c7bb33a453eacc5c5cd5502c8f1/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hexon Rush",
      "description": "Hexon Rush is a time limited puzzle game with a little bit of sci-fi look.\n\nMain goal in the Hexon Rush is connecting all the lines inside the hexagonal tiles before time runs out.  There are 600 levels with increasing size, difficulty and complexity.\n\nDon't worry, you will have two types of helpers to solve these puzzles. Be careful when you spend them because they are hard to obtain.",
      "instructions": "Click on hexagon tiles to rotate them counter-clockwise.\nAt the bottom of screen there are helpers.\nClick on the left one to freeze countdown for 5 seconds.\nClick on the right one to lock half of tiles in correct rotation automatically.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "geometry",
        "hexagon",
        "math",
        "singleplayer",
        "timer"
      ]
    },
    "zh-CN": {
      "title": "赫克森狂奔",
      "description": "Hexon Rush是一款有时间限制的益智游戏，略带科幻风格。\n\n在Hexon Rush中的主要目标是，在时间耗尽前连接所有六边形瓷砖内的线条。共有600个关卡，难度、大小和复杂性逐级提升。\n\n别担心，你将拥有两种类型的助手来解决这些谜题。使用它们时要小心，因为它们很难获得。",
      "instructions": "点击六边形瓷砖以逆时针旋转它们。\n屏幕底部有辅助工具。\n点击左侧的辅助工具以冻结倒计时5秒。\n点击右侧的辅助工具以自动锁定一半瓷砖到正确旋转。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "几何",
        "六边形",
        "数学",
        "单人游戏",
        "计时器"
      ]
    },
    "zh-TW": {
      "title": "赫克森急速",
      "description": "Hexon Rush 是一款時間有限的謎題遊戲，帶有一點科幻風格。\n\n在 Hexon Rush 的主要目標是在時間耗盡前將所有線條連接在六邊形磚塊內。遊戲共有 600 個等級，隨著等級的提升，難度和複雜度也會增加。\n\n別擔心，你將會有兩種幫助你解謎的助手。在使用它們時要小心，因為它們很難獲得。",
      "instructions": "點擊六邊形圖塊以逆時針旋轉。\n畫面底部有幫助工具。\n點擊左邊的按鈕以凍結倒數5秒。\n點擊右邊的按鈕以自動鎖定一半圖塊至正確旋轉。",
      "genres": [
        "休閒",
        "謎題"
      ],
      "tags": [
        "幾何學",
        "六邊形",
        "數學",
        "單人遊戲",
        "計時器"
      ]
    },
    "zh-HK": {
      "title": "賀克斯頓狂奔",
      "description": "Hexon Rush是一款時間有限的謎題遊戲，帶有一絲科幻風格。\n\n在Hexon Rush中的主要目標是在時間耗盡前，將所有六邊形瓦片內的線條連接起來。遊戲共有600個等級，隨著等級的提升，難度和複雜度也逐漸增加。\n\n不必擔心，你將會有兩種助手來幫助你解謎。在使用它們時請小心，因為它們難以獲得。",
      "instructions": "點擊六邊形地圖塊以逆時針旋轉。\n畫面底部有幫助工具。\n點擊左邊的一個以凍結倒數5秒。\n點擊右邊的一個以自動鎖定半數地圖塊至正確旋轉。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "幾何",
        "六邊形",
        "數學",
        "單人遊戲",
        "計時器"
      ]
    },
    "ja": {
      "title": "ヘクソン・ラッシュ",
      "description": "ヘクソン・ラッシュは、少しSF的な外見の時間制限付きのパズルゲームです。\n\nヘクソン・ラッシュの主な目標は、時間切れになる前に六角形のタイル内のすべてのラインを接続することです。レベルは600あり、サイズ、難易度、複雑さが増していきます。\n\n心配しないで、これらのパズルを解くための2種類のヘルパーがあります。ただし、手に入れるのが難しいので、使い方には注意してください。",
      "instructions": "六角形のタイルをクリックして反時計回りに回転させます。\nスクリーンの下部にはヘルパーがあります。\n左のものをクリックして5秒間カウントダウンを停止させます。\n右のものをクリックして、半分のタイルが自動的に正しい回転にロックされます。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "幾何学",
        "六角形",
        "数学",
        "一人用",
        "タイマー"
      ]
    },
    "ko": {
      "title": "헥슨 러시",
      "description": "헥스론 러시는 시간 제한이 있는 파ズル 게임으로,科幻적인 외관을 가지고 있습니다.\n\n헥스론 러시의 주요 목표는 시간이 다해 전에 육각형 타일 내부의 모든 선을 연결하는 것입니다. 총 600개의 레벨이 있으며, 크기, 난이도, 복잡성이 증가합니다.\n\n또 두 가지 유형의 도우미를 사용할 수 있습니다. 그러나 사용할 때는 주의하십시오,因为这些 도우미를 얻기 어렵기 때문입니다.",
      "instructions": "사각형 타일을 클릭하여 시계 방향 반대로 회전하세요.\n화면 아래에는 도움 도구가 있습니다.\n왼쪽 하나를 클릭하여 5초 동안 카운트다운을 멈추세요.\n오른쪽 하나를 클릭하여 절반의 타일이 자동으로 올바른 회전으로 고정됩니다.",
      "genres": [
        "캐주얼",
        "패ズル"
      ],
      "tags": [
        "幾何학",
        "육각형",
        "수학",
        "싱글플레이어",
        "타이머"
      ]
    },
    "fr": {
      "title": "Hexon Rush",
      "description": "Hexon Rush est un jeu de puzzle à temps limité avec un aspect un peu de science-fiction.\n\nL'objectif principal dans Hexon Rush est de connecter toutes les lignes à l'intérieur des tuiles hexagonales avant que le temps ne se termine. Il y a 600 niveaux avec une taille, une difficulté et une complexité croissantes.\n\nNe vous inquiétez pas, vous disposerez de deux types d'assistant pour résoudre ces puzzles. Faites attention à leur utilisation, car ils sont difficiles à obtenir.",
      "instructions": "Cliquez sur les tuiles hexagonales pour les faire pivoter dans le sens inverse des aiguilles d'une montre.\nEn bas de l'écran, il y a des assistants.\nCliquez sur le gauche pour geler le décompte pendant 5 secondes.\nCliquez sur le droit pour verrouiller automatiquement la moitié des tuiles à la rotation correcte.",
      "genres": [
        "Accordéon",
        "Puzzle"
      ],
      "tags": [
        "géométrie",
        "hexagone",
        "mathématiques",
        "mode solo",
        "chronomètre"
      ]
    }
  }
};
